<ng-container *transloco="let t;">
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">
            {{section ==='contract_control' ? t('Add contract control modal title - (Contract control listing section) -
            New Contract Card') : t('Heading text (contractControl stepForm) - Add to Contract Control')}}
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="addConfirmCloseModalClick()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body add-contract-control-modal-wrapper p-0" [ngClass]="{'hide-nav-buttons': (section === 'contract_control')}" tabindex="0"
        ngbAutofocus>
        <div class="tabs-area-container">
            <ul ngbNav #nav="ngbNav" class="nav-tabs" [activeId]="section === 'contract_control' ? 'create' : 'search'">
                <li [ngbNavItem]="'search'">
                    <a ngbNavLink>{{t('Link text (contractControl stepForm) - Attach to existing contract')}}</a>
                    <ng-template ngbNavContent>
                        <div class="contract-box">
                            <div class="input-group input-group-merge mb-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i data-feather="search"></i>
                                    </span>
                                </div>
                                <ng-autocomplete class="form-control CC_autoCompleteSearch px-0" #auto
                                    [data]="_searchedContracts$" (inputChanged)="searchContract($event)"
                                    (inputCleared)="clearContractSearch($event)"
                                    [searchKeyword]="_searchContractKeyword"
                                    [placeholder]="t('Search contract placeholder (contractControl stepForm) - Search contract')"
                                    (selected)='selectContract($event);auto.clear()' [itemTemplate]="itemTemplate"
                                    [notFoundTemplate]="notFoundTemplate" [isLoading]="contractLoading">
                                </ng-autocomplete>
                                <ng-template #itemTemplate let-item>
                                    <a [innerHTML]="item.contract_control_name"></a>
                                </ng-template>
                                <ng-template #notFoundTemplate let-notFound>
                                    <div [innerHTML]="notFound"></div>
                                </ng-template>
                            </div>
                        </div>
                    </ng-template>
                </li>
                <li [ngbNavItem]="'create'">
                    <a ngbNavLink>{{t('Link text (contractControl stepForm) - Create new')}}</a>
                    <ng-template ngbNavContent>
                        @if ( initialStep === true){
                        <div class="steps-options-container">

                            <app-create-cc-by-ai-form [uploadFileForm]="addTocontractForm.get('autoFillUploadFile')"
                                [formSubmitted]="uploadAIFormSubmitted" [maxFileSize]="maxFileSize"
                                [acceptableFiles]="acceptableFiles" [processingPDF]="processingPDF"
                                [documentTypes]="documentTypes$ | async"></app-create-cc-by-ai-form>
                            <div class="steps-footer-buttons modal-footer pull-right px-0">
                                <button type="button" class="btn btn-outline-secondary me-1" [disabled]="processingPDF"
                                    rippleEffect (click)="skipUpload()">
                                    {{t('Skip upload button text on first auto-fill step (Auto-Fill Form via OpenAI PDF)
                                    - Please wait - Skip upload step')}}
                                </button>

                                <button type="button" class="btn btn-primary m-0"
                                    [disabled]="processingPDF || (uploadAIFormSubmitted && addTocontractForm?.get('autoFillUploadFile')?.invalid)"
                                    rippleEffect (click)="beginCCCreation()">
                                    {{t('Next (general) - Next')}}
                                </button>
                            </div>
                        </div>
                        } @else {
                        <div class="progress-wrapper add-to-contract-control-right-sidebar-progress mb-0">
                            <ngb-progressbar type="success" [value]="progress">
                            </ngb-progressbar>
                        </div>
                        <form [formGroup]="addTocontractForm" (ngSubmit)="saveAndConnectContract()">
                            <div class="steps-options-container">

                                <ng-container *ngIf="stepsCount === 1">
                                    <app-contract-form [documentTypes]="documentTypes$ | async"
                                        [aiProcessedData]="aiDataExtracted"
                                        [contractForm]="addTocontractForm.get('contractForm')"
                                        (newDocumentTypeToCreate)="newDocumentTypeByAI($event)"
                                        (newCategoryToCreate)="newCategoryByAI($event)"
                                        (newOrganisationToCreate)="newOrganisationByAI($event)"></app-contract-form>
                                </ng-container>

                                <ng-container *ngIf="stepsCount === 2">
                                    <app-period-renewal-form [aiProcessedData]="aiDataExtracted"
                                        [periodRenewalForm]="addTocontractForm.get('periodRenewalForm')"></app-period-renewal-form>
                                </ng-container>

                                <ng-container *ngIf="stepsCount === 3">
                                    <app-cost-form *ngIf="boxesSettings.cost" [aiProcessedData]="aiDataExtracted"
                                        [contractForm]="addTocontractForm"></app-cost-form>
                                </ng-container>


                                <ng-container *ngIf="stepsCount === 4">
                                    <app-revenue-form *ngIf="boxesSettings.revenue" [aiProcessedData]="aiDataExtracted"
                                        [contractForm]="addTocontractForm"></app-revenue-form>
                                </ng-container>

                                <ng-container *ngIf="stepsCount === 5">
                                    <app-managers *ngIf="boxesSettings.manager" [aiProcessedData]="aiDataExtracted"
                                        [mainFormGroup]="addTocontractForm"></app-managers>
                                </ng-container>

                                <ng-container *ngIf="stepsCount === 6">
                                    <app-contacts *ngIf="boxesSettings.contacts" [aiProcessedData]="aiDataExtracted"
                                        [mainFormGroup]="addTocontractForm"></app-contacts>
                                </ng-container>

                                <ng-container *ngIf="stepsCount === 7">
                                    <div class="contract-control-step-six">
                                        <h2 class="step-heading-title">&nbsp;</h2>
                                        <div *ngFor="let customBoxData of getCustomBoxesControl.value; let i = index;">
                                            <div class="customBoxMaincontainer card-transaction">
                                                <h6 class="mb-1 fw-600 font-medium-1">{{ customBoxData?.name }}</h6>
                                                <app-custom-box [mainFormGroup]="addTocontractForm"
                                                    [customBoxes]="getCustomBoxesControl.value"
                                                    [document_type_custom_boxes_data]="customBoxData?.document_type_custom_boxes_data"></app-custom-box>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="stepsCount === 8">
                                    <app-final-step [aiProcessedData]="aiDataExtracted"
                                        [mainFormGroup]="addTocontractForm"></app-final-step>
                                </ng-container>

                                <div class="steps-footer-buttons modal-footer px-0 pb-0 pt-1 mt-1">
                                    <button type="button" class="btn btn-outline-secondary m-0"
                                        [disabled]="stepsCount === 0" rippleEffect (click)="prevPage()">
                                        {{t('Previous (general) - Previous')}}
                                    </button>
                                    <button type="button" *ngIf="stepsCount < 8" class="btn btn-primary m-0"
                                        rippleEffect (click)="changePage(1)">
                                        {{t('Next (general) - Next')}}
                                    </button>
                                    <button type="submit" *ngIf="stepsCount === 8" class="btn btn-success m-0"
                                        rippleEffect>
                                        <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                                        {{section ==='contract_control' ? t('Create and view button text
                                        (contractControl stepForm) - Create and view') : t('Save button text (save
                                        button) - save')}}
                                    </button>
                                </div>
                            </div>
                        </form>
                        }

                    </ng-template>
                </li>
            </ul>
            <div [ngbNavOutlet]="nav" class="mt-2 mb-2 tab-content ps-2 pe-2 position-relative"></div>
        </div>
    </div>

</ng-container>